<template>
<div>
  <sign-up :project-id="projectId" :project-name="projectName" v-bind:is-sign-up.sync="isSignUp"/>
  <Top />
  <div class="maindiv eindex-wrap">
    <Banner />
    <div class="sys htmldiv tright twhite ofhidden">
      <!-- <a href="/sims/web" class="zbtn zbtn-gblue fr">
        <div class="fs24 mb5">管理端入口</div>
        <div class="fmt tupper">Management side</div>
      </a> -->
      <a href="/lms/web" target="_blank" class="zbtn zbtn-gblue fr">
        <div class="fs24 mb5">学习端入口</div>
        <div class="fmt tupper">Learning Entrance</div>
      </a>
      <a @click="signUpItem(51,'2022级仙通成考前培训')" href="javascript:;" class="fr" style="width: 250px;height: 72px;text-align: center;background: #147ad8;color: #fff;">
        <div class="fs24 mb5" style="margin-top: 10px;">点击报名</div>
        <div class="fmt tupper">Click</div>
      </a>
    </div>
    <ProIntroduction :proIntroduction="proIntroduction"/>
    <div class="newsdiv htmldiv pb20">
      <ListLeft :notice="notice"/>
      <ListRight :action="'eninfo'" :title="'招生信息'" :infos="student"/>
      <ListRight :action="'policy'" :title="'政策文件'" :infos="policy"/>
    </div>
  </div>
  <Bottom />
</div>
</template>

<script>
import Top from '../top.vue'
import Banner from '../banner.vue'
import ProIntroduction from './pro-introduction.vue'
import ListLeft from './list-left.vue'
import ListRight from './list-right.vue'
import Bottom from '../bottom.vue'
import SignUp from "@/components/train/project/signUp";
export default {
  name: "index",
  data () {
    return {
      'proIntroduction': [],
      'notice': [],
      'student': [],
      'policy': [],
      'isSignUp':false,
      'projectId':0,
      'projectName':'',
    }
  },
  components:{
    Top,
    Banner,
    ProIntroduction,
    ListLeft,
    ListRight,
    Bottom,
    SignUp,
  },
  methods:{
    signUpItem(id,name){
      this.projectId=id;
      this.projectName=name;
      this.isSignUp=true;
    },
  },
  created() {
    this.$request.get('academic-education/index', {},response => {
      if(response.status == 200){
        this.proIntroduction = response.data.data.academicMajorList;
        this.notice = response.data.data.noticeList;
        this.student = response.data.data.enrollmentList;
        this.policy = response.data.data.policyList;
      }
      console.log(response);
    },error => {
      console.log(error);
    })
  },
}
</script>

<style scoped>
  .sys{margin-top: -45px;}
  .sys .zbtn{padding: 10px 45px 0 85px;height: 72px;background: #0b457e url(../../../assets/images/cn1.png) 10px -423px;text-align: left;}
  .sys .zbtn:hover{background-color: #174989;}


  .eindex-wrap .newsdiv .sdiv{width: 360px;}
  .eindex-wrap .newsdiv .sdiv:nth-child(2n){margin: 0 90px;}
</style>



// WEBPACK FOOTER //
// src/components/aedu/index/index.vue